import { useSelector } from "react-redux";
import { useUrlSearch } from "../../../../../hooks/useUrlSearch";
import {
  useGetActivityLogModules,
  useGetActivityLogs,
  useGetUserList,
} from "../../../../../hooks/api/queries/useSettings";

export const useAllActivityLogs = () => {
  const {
    search,
    queries,
    setSearch,
    gotoPage,
    filterByStoreId,
    filterBySearch,
    filterByKey,
    filterByDate,
  } = useUrlSearch();
  const { storeList } = useSelector((state) => state.profileDetailsReducer);

  const { data, isLoading } = useGetActivityLogs({ queries });
  const { data: activityModules, isLoading: isLoadingModules } =
    useGetActivityLogModules();
  const { data: userList, isLoading: isLoadingUsers } = useGetUserList();

  return {
    search,
    activityLogs: data?.data || [],
    metaDetails: data?.meta || {},
    activityModules: activityModules?.data || [],
    isLoading: isLoadingUsers || isLoading || isLoadingModules,
    userList: userList || [],
    storeList,
    filterByStoreId,
    setSearch,
    gotoPage,
    filterByDate,
    filterBySearch,
    filterByKey,
  };
};
